export default "__VITE_ASSET__z1oO9XXi__"